import _ from 'lodash'
import Constants from '@/utils/Constants'
import ApiManager from '../../utils/ApiManager'
import Vue from 'vue'

const initialProductGroup = () => {
  return {
    id: null,
    name: '',
    tag: '',
    publish_setting: 0,
    conditions: '',
    details: [],
    code_pattern: 2,
    contract_flag: 2,
    product_area_code: 1,
    condition: {
      mode: 'group',
      code: [],
      name: [],
      file_name: '',
      file: [],
      group: [],
      category: {
        product_area_code: 1,
        code: []
      },
      category_group: {
        product_area_code: 1,
        id: []
      },
      product_attribute: [],
      freeword: '',
      code_exclude: []
    }
  }
}

const state = {

  loading: false,
  isSubmit: false,

  //  商品初期データ
  constData: {
    product_area: [],
    product_group: [],
    productCategoryLevel: 1,
    product_category: [],
    category_group: [],
    product_attribute_l: [],
    product_attribute_s: []
  },
  //  site,contract,userデータ
  customData: {
    isUseCodePattern: false,
    isUseContractFlag: false,
    isUsePublishSetting: true,
    isUseProductAttribute: false, //  contract.product_attribute_use != 1の場合、商品属性から選択を非表示とする
    categoryRankName: [] //  カテゴリ階層名
  },
  product_group: initialProductGroup(),
  //  商品カート設定
  cartSettings: [
    {},
    // cartSeetings[1] (商品コード)
    {
      labelName: 'item_name',
      keyName: 'item_code'
    },
    // cartSeetings[2] (janコード)
    {
      labelName: 'jannm',
      keyName: 'jancd'
    }
  ],
  message: {
    content: '',
    type: ''
  }
}

const actions = {

  async init ({ dispatch, state, commit }) {
    const param = {
      code: Vue.localStorage.get('groupMode')
    }
    //  ページ初期データ読み込み
    const resConst = await ApiManager.request('Analyze').analyzeInit(param)
    //  ページデータcommit
    commit('setConstData', resConst.data.data)
    commit('setLoading', false)
  },
  /**
   * 利用コードを変更したらリセット
   */
  submitCodePattern ({ dispatch, state, commit }, payload) {
    //  初期化
    commit('setCodePattern', payload)
    if (!state.isSubmit) {
      return
    }
    commit('setCartItem', {
      data: []
    })
    commit('setIsSubmit', false)
    const mode = state.product_group.condition.mode
    if (mode === 'name') {
      commit('setName', [])
    } else if (mode === 'category_group') {
      commit('setCategoryGroup', {
        product_area_code: 1,
        id: []
      })
    } else if (mode === 'product_attribute') {
      commit('setProductAttribute', [])
    } else {
      dispatch('setCondition')
    }
  },
  //  商品グループ決定
  async submitGroup ({ commit }, payload) {
    commit('setLoading', true)
    let res
    if (state.product_group.code_pattern === 1) {
      const param = {
        id: payload,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchGroup(param)
    } else {
      const param = {
        id: payload,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchGroup(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setGroup', payload)
    }
    commit('setLoading', false)
  },
  /**
   * カテゴリーリストからカートに商品を追加
   */
  async submitCategory ({ state, commit }, payload) {
    commit('setLoading', true)

    let res
    let param = {}
    param.code = payload.code
    if (state.product_group.code_pattern === 1) {
      param.product_area_code = payload.product_area_code
      param.analyze_target_code = Vue.localStorage.get('groupMode')
      param.contract_flag = state.product_group.contract_flag
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCategory(param)
    } else {
      param.product_area_code = null
      param.analyze_target_code = Vue.localStorage.get('groupMode')
      param.contract_flag = state.product_group.contract_flag
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCategory(param)
    }
    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setCategory', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 商品コード決定からカートに商品を追加
   * @param {object} payload
   */
  async submitCode ({ state, commit }, payload) {
    commit('setLoading', true)
    let res
    if (state.product_group.code_pattern === 1) {
      const param = {
        code: payload,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCode(param)
    } else {
      const param = {
        code: payload,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCode(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setCode', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 商品名決定からカートに商品を追加
   * @param { String } payload 商品名
   */
  async submitName ({ state, commit }, payload) {
    commit('setLoading', true)
    if (state.product_group.code_pattern === 2) {
      const param = {
        name: payload,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      let res = await ApiManager.request('ProductSearch').productSearchName(param)

      if (res.data.data.length > 0) {
        const data = {
          data: res.data.data
        }

        commit('setIsSubmit', true)
        commit('setCartItem', data)
        commit('setName', payload)
      }
    }
    commit('setLoading', false)
  },
  /**
   * ファイルのアイテムリストからカートに商品を追加
   * @param { Array } payload 商品コード
   */
  async submitFile ({ state, commit }, payload) {
    commit('setLoading', true)
    let res
    if (state.product_group.code_pattern === 1) {
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchFile(payload.file,
        Vue.localStorage.get('groupMode'), state.product_group.contract_flag)
    } else {
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchFile(payload.file,
        Vue.localStorage.get('groupMode'), state.product_group.contract_flag)
    }

    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setFile', payload)
    } else {
      this.dispatch('routerdata/setApiMessage', res.data.data.message)
    }
    commit('setLoading', false)
  },
  //  商品カテゴリグループ決定
  async submitCategoryGroup ({ state, commit }, payload) {
    commit('setLoading', true)

    let res
    if (state.product_group.code_pattern === 1) {
      const param = {
        id: payload.id,
        product_area_code: payload.product_area_code,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCategoryGroup(param)
    } else {
      const param = {
        id: payload.id,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCategoryGroup(param)
    }

    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setCategoryGroup', payload)
    }
    commit('setLoading', false)
  },
  /**
   * 商品属性決定からカートに商品を追加
   */
  async submitAttribute ({ state, commit }, payload) {
    commit('setLoading', true)
    const param = {
      l_levels_and_s_ids: payload
    }
    let res = await ApiManager.request('ProductAttribute').productAttributeJancdList(param)

    if (res.data.data.length > 0) {
      const data = {
        data: res.data.data
      }

      commit('setIsSubmit', true)
      commit('setCartItem', data)
      commit('setProductAttribute', { code: payload })
    }
    commit('setLoading', false)
  },
  //  フリーワード検索決定
  async submitFreeword ({ state, commit }, payload) {
    commit('setLoading', true)

    let res
    if (state.product_group.code_pattern === 1) {
      const param = {
        code: payload.data,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  商品コード利用
      res = await ApiManager.request('ItemSearch').itemSearchCode(param)
    } else {
      const param = {
        code: payload.data,
        analyze_target_code: Vue.localStorage.get('groupMode'),
        contract_flag: state.product_group.contract_flag
      }
      //  JANコード利用
      res = await ApiManager.request('ProductSearch').productSearchCode(param)
    }

    const data = {
      data: res.data.data
    }

    commit('addCartItem', data)
    commit('setFreeword', payload)
    commit('setLoading', false)
  },
  async detail ({ dispatch, state, commit }, payload) {
    let type = 'success'

    let response = null
    if (payload.codePattern === '2') {
      response = await ApiManager.request('ProductGroup').productGroupJanDetail(payload.id)
    } else {
      response = await ApiManager.request('ProductGroup').productGroupProductDetail(payload.id, payload.productAreaCode)
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setProductGroup', response.data)

      const condition = JSON.parse(response.data.data.conditions)
      commit('setCondition', condition)
      commit('setIsSubmit', true)
      // dispatch('setCondition')
      return response.data.data
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    return null
  },
  setCondition ({ state, commit, dispatch }) {
    // commit('setIsSubmit', false)
    const analyze = state.product_group.condition
    let mode = analyze.mode
    if (mode === 'group') {
      if (analyze.group.length > 0) {
        // dispatch('submitGroup', analyze.group)
        commit('setIsSubmit', true)
        commit('setGroup', analyze.group)
      }
    } else if (mode === 'category') {
      if (analyze.category.code.length > 0) {
        // dispatch('submitCategory', analyze.category)
        commit('setIsSubmit', true)
        commit('setCategory', analyze.category)
      }
    } else if (mode === 'code') {
      if (analyze.code.length > 0) {
        // dispatch('submitCode', analyze.code)
        commit('setIsSubmit', true)
        commit('setCode', analyze.code)
      }
    } else if (mode === 'name') {
      if (analyze.name.length > 0) {
        // dispatch('submitName', analyze.name)
        commit('setIsSubmit', true)
        commit('setName', analyze.name)
      }
    } else if (mode === 'file') {
      if (analyze.file_name.length > 0) {
        // dispatch('submitFile', analyze.file_name)
        commit('setIsSubmit', true)
        commit('setFile', analyze.file_name)
      }
    } else if (mode === 'category_group') {
      if (analyze.category_group.id.length > 0) {
        // dispatch('submitCategoryGroup', analyze.category_group)
        commit('setIsSubmit', true)
        commit('setCategoryGroup', analyze.category_group)
      }
    } else if (mode === 'product_attribute') {
      if (analyze.product_attribute.code.length > 0) {
        // dispatch('submitAttribute', analyze.product_attribute)
        commit('setIsSubmit', true)
        commit('setProductAttribute', { code: analyze.product_attribute })
      }
    }
  },
  async save ({ state, commit }, productGroup) {
    commit('setLoading', true)
    let response = null
    productGroup.conditions = JSON.stringify(state.product_group.condition)
    if (productGroup.id) {
      response = await ApiManager.request('ProductGroup').productGroupEdit(productGroup)
    } else {
      productGroup.analyze_target_code = Vue.localStorage.get('groupMode')
      response = await ApiManager.request('ProductGroup').productGroupAdd(productGroup)
    }
    let type = 'success'
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      type = 'error'
    }
    commit('setMessage', { content: response.data.data.message, type: type })
    commit('setLoading', false)
  }
}

const mutations = {
  setLoading (state, data) {
    state.loading = data
    if (data) {
      this.dispatch('loading/loadingPagePlus')
    } else {
      this.dispatch('loading/loadingPageMinus')
    }
  },
  setProductGroup (state, data) {
    state.product_group.id = data.data.id
    state.product_group.name = data.data.name
    state.product_group.tag = data.data.tag
    state.product_group.publish_setting = data.data.publish_setting
    state.product_group.code_pattern = data.data.code_pattern
    state.product_group.contract_flag = data.data.contract_flag
    state.product_group.product_area_code = data.data.product_area_code
    const keys = state.cartSettings[data.data.code_pattern]
    state.product_group.details = _.map(data.details, item => {
      let r = {}
      r[keys['keyName']] = item.code
      r[keys['labelName']] = item.name
      return r
    })
  },
  setConstData (state, data) {
    Object.keys(state.constData).forEach(
      key => {
        if (key in data) {
          state.constData[key] = data[key]
        } else {
          state.constData[key] = []
        }
      }
    )
    if (!state.product_group.product_area_code && state.constData.product_area.length) {
      state.product_group.product_area_code = state.constData.product_area[0].code
    }
    const isItemUse = Constants.getSite('is_item_use')
    if (isItemUse && ((isItemUse - 0) === 1)) {
      state.customData.isUseCodePattern = true
    } else {
      state.customData.isUseCodePattern = false
    }

    state.customData.isUseContractFlag = true
    const division = Constants.getContract('division')
    if (division) {
      const num = division - 0
      if (num === 1 || num === 2 || num === 5) {
        state.customData.isUseContractFlag = false
      }
    }

    state.customData.isUseProductAttribute = false
    const productAttributeUse = Constants.getContract('product_attribute_use')
    if (productAttributeUse !== 1) {
      state.customData.isUseProductAttribute = true
    }

    const groupPublishSettingFlag = Constants.getContract('group_publish_setting_flag')
    if (groupPublishSettingFlag === 0) {
      state.customData.isUsePublishSetting = false
    }

    //  カテゴリ階層算出
    let maxrank = Constants.getSite('product_category_rank_qty')
    state.constData.productCategoryLevel = maxrank - 0
    //  カテゴリ階層名
    state.customData.categoryRankName = Constants.getSite('product_category_rank_name')
    if (!state.customData.categoryRankName) {
      state.customData.categoryRankName = [
        '',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択',
        'カテゴリを選択'
      ]
    }
  },
  setIsSubmit (state, data) {
    state.isSubmit = data
  },
  setCondition (state, data) {
    state.product_group.condition = data
  },
  setCodePattern (state, data) {
    state.product_group.code_pattern = data
  },
  setContractFlag (state, data) {
    state.product_group.contract_flag = data
  },
  setProductAreaCode (state, data) {
    state.product_group.product_area_code = data
  },
  setGroup (state, data) {
    state.product_group.condition.group = data
    state.product_group.condition.mode = 'group'
  },
  setCategory (state, data) {
    state.product_group.condition.category = data
    state.product_group.condition.mode = 'category'
  },
  setCategoryGroup (state, data) {
    state.product_group.condition.category_group = data
    state.product_group.condition.mode = 'category_group'
  },
  setProductAttribute (state, data) {
    state.product_group.condition.product_attribute = data
    state.product_group.condition.mode = 'product_attribute'
  },
  setCode (state, data) {
    state.product_group.condition.code = data
    state.product_group.condition.mode = 'code'
  },
  setName (state, data) {
    state.product_group.condition.name = data
    state.product_group.condition.mode = 'name'
  },
  setFile (state, data) {
    state.product_group.condition.file_name = data.file.name
    state.product_group.condition.mode = 'file'
  },
  setFreeword (state, data) {
    state.product_group.condition.freeword = data.freeword
  },
  clearCartItem (state, data) {
    state.product_group.details = []
    state.isSubmit = false
  },
  setCartItem (state, data) {
    state.product_group.details = data.data
  },
  addCartItem (state, data) {
    if (data.data[0]) {
      let field = 'jancd'
      if (!('jancd' in data.data[0])) {
        field = 'item_code'
      }
      state.product_group.details = _.unionBy(state.product_group.details, data.data, field)
    }
  },
  resetProductGroup (state, data) {
    const productGroup = initialProductGroup()
    _.each(productGroup, (value, key) => {
      state.product_group[key] = value
    })
    state.isSubmit = false
  },
  setMessage (state, data) {
    state.message = data
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
